import { render, staticRenderFns } from "./NotesTable.vue?vue&type=template&id=0653b8e4"
import script from "./NotesTable.vue?vue&type=script&lang=js"
export * from "./NotesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports